import { Message } from "element-ui";
//  账号
export const accountRule= (rule, value, callback) => {
  let regFormat = /^[A-Za-z0-9]{5,16}/; // 正确的账号
  if (!value) {
    return callback(Message.error("账号不能为空！"))
  }
  if (!(regFormat.test(value))) {
    return callback(Message.error("请输入正确的账号"))
  } else {
    return callback();
  }
};

// 密码
export const passwordRule = (rule, value, callback) => {
  let regFormat = /^[A-Za-z0-9]{6,16}/;
  if (!value) {
    return callback(Message.error("密码不能为空！"));
  }
  if (!(regFormat.test(value))) {
    return callback(Message.error("密码为6-16位数字或者字母"));
  } else {
    return callback();
  }
};

// 姓名
export const name = (rule, value, callback) => {
  if (!value) {
    return callback(Message.error("用户名不能为空！"))
  } else {
    callback();
  }
};

// 公司的名字
export const companyName = (rule, value, callback) => {
  if (!value) {
    return callback(Message.error("用户名不能为空！"));
  } else {
    callback();
  }
};

// 表单 tel
export const tel = (rule, value, callback) => {
  let regFormat = /^[0-9]*$/;
  if ( value && !(regFormat.test(value))) {
    return callback(Message.error("联系电话只能是数字！！"));
  } else {
    return callback();
  }
};
// 规程code
export const regulationsCode = (rule, value, callback) => {
  if (!value) {
    return callback(Message.error("规程代码不能为空！"))
  } else {
    callback();
  }
};
// 规程名字
export const regulationsName = (rule, value, callback) => {
  if (!value) {
    return callback(Message.error("规程名字不能为空！"))
  } else {
    callback();
  }
};
// 名称不能为空
export const deviceName = (rule, value, callback) => {
  if (!value) {
    return callback(Message.error("名称不能为空！"))
  } else {
    callback();
  }
};
// 证书编号不能为空
export const certCode = (rule, value, callback) => {
  if (!value) {
    return callback(Message.error("证书编号不能为空！"))
  } else {
    callback();
  }
};
// 模版名称不能为空
export const stenName = (rule, value, callback) => {
  if (!value) {
    return callback(Message.error("模版名称不能为空！"))
  } else {
    callback();
  }
};
// cityidRule 区域选择
export const cityidRule= (rule, value, callback) => {
  if (!value) {
    return callback(Message.error("区域选择不能为空！"))
  } else {
    callback();
  }
};
